<template>
  <div></div>
</template>

<script>
import "./UserProfile.scss";
// import { mapActions } from "vuex";

export default {
  name: "UserProfile",
  data: () => ({}),
  methods: {},
};
</script>
